import React from 'react';
import PropTypes from 'prop-types';
import { StyledTBody } from './style';

const TBody = ({ children }) => <StyledTBody>{children}</StyledTBody>;

TBody.propTypes = {
  children: PropTypes.node.isRequired
};

export default TBody;
